import { VizContext } from '@bitrise/bitviz';
import classnames from 'classnames';
import { motion } from 'framer-motion';
import React, { useContext, FunctionComponent } from 'react';
import { EventSeriesPoint, POINT_HEIGHT, POINT_WIDTH } from './SessionEventsVisualisation';

interface Props {
  focus: boolean;
  point: EventSeriesPoint;
}

const SessionEventsVisualisationSeriesPoint: FunctionComponent<Props> = (props) => {
  const { focus, point } = props;
  const { getX, getY } = useContext(VizContext);
  const classes = classnames('EventsSeries__point', {
    'EventsSeries__point--crash': point.name === 'Crash',
    'EventsSeries__point--focus': focus,
  });

  const x = getX(point.x);
  const y = getY(point.y);

  return (
    <>
      <motion.g
        {...props}
        animate={{
          scaleY: 1,
          x,
          y,
        }}
        className={classes}
        initial={{
          scaleY: 0,
          x,
          y,
        }}
      >
        <circle className="EventsSeries__point-background" r={POINT_HEIGHT / 4} />

        <rect
          className="EventsSeries__point-dot"
          height={POINT_HEIGHT}
          rx={2}
          width={POINT_WIDTH}
          x={POINT_WIDTH * -0.5}
          y={POINT_HEIGHT * -0.5}
        />
      </motion.g>
    </>
  );
};

export default SessionEventsVisualisationSeriesPoint;
